import React, { useCallback, useState, useEffect, useRef, useMemo } from 'react'
import { withWindowSizeListener } from 'react-window-size-listener'
import '../styles/components/PerfilGridSkeleton.css'
import Shimmer from './Shimmer'

const PerfilGridSkeleton = ({ windowSize: { windowWidth, windowHeight } }) => {
  const renderShimmers = useCallback(() => {
    const [imageWidth, setImageWidth] = useState(0)
    const imageRef = useRef(null)

    const shimmersAmount = useMemo(() => {
      if (windowHeight && windowHeight - 48 - 100 > 0 && windowWidth && windowWidth > 0) {
        return Math.ceil((windowHeight - 48 - 100) / ((4 * (imageWidth || 300)) / 3)) * 2
      } else {
        return 0
      }
    }, [windowHeight, windowWidth, imageWidth])

    /*
      listen the window width, when the window width changes, update
      the image width to calculate the new height based on the new width

      obs: similar to aspect-ratio property
    */
    useEffect(() => {
      imageRef.current && setImageWidth(imageRef.current.offsetWidth)
    }, [windowWidth])

    return (new Array(shimmersAmount)).fill(0).map((_, index) => (
      <Shimmer key={index} ref={imageRef} className='perfil-grid-skeleton-item'
        style={{ height: 4 * imageWidth / 3 }} />
    ))
  }, [windowWidth])

  return (
    <div className='perfil-grid-skeleton-contaienr'>
      {renderShimmers()}
    </div>
  )
}

export default withWindowSizeListener(PerfilGridSkeleton)



// WEBPACK FOOTER //
// ./src/components/PerfilGridSkeleton.js